

import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import loading from '@/components/public-components/loading/index.vue'
import EsQuery from '@/javascript/esQuery'
import payPublic from '@/javascript/payPublic'
import util from "@/javascript/util"
import Preview from '@/components/public-components/image-preview/index'
export default {
components: {
Tab,
TabItem,
Preview,
loading
},
data () {
return {
isWeixin: util.isWeiXin(),
minHeight: 0,
detailsData: {},
pageNo: 0,
pageSize: 5,
infiniteAll: false,
infiniteStatus: false,
isShow: false,
menuSlide: false,
noShow: false,
businessList: [],
foodList: [],
tabIndex: 0,
diningList: [],
curNear: 0,
nearList: [],
positionData: '',
showBtn: false,
once: false,
showNum: 3,
imageList: [],
currentPage: 1,
videoSwiper: '',
actIndex: 0,
}
},
mounted () {
this.minHeight = document.documentElement.clientHeight

window.addEventListener('scroll', this.windowScroll)

this.getDetailsData()

},
watch: {
"$route": {
handler (val) {
this.getDetailsData()
}
}
},
methods: {
callPhone () {
if (this.detailsData && this.detailsData.phone && this.detailsData.phone != "暂无") {
const param = {
phone: this.detailsData.phone
}
payPublic.callPhone(param)
} else {
alert("暂无电话")
}
},


getDetailsData () {
const _this = this
_this.$http.get("/api/wtcp-ecrm/public/product/info/" + _this.$route.params.id).then(res => {
const data = res.data.data
if (data.openTime) {
data.openTime = data.openTime.split(',')
}

data.imageList.forEach(item => {
if (item.url.indexOf('\\') != -1) {
item.url = item.url.replaceAll("\\", "/\/")
}
_this.$set(item, 'src', _this.PIC_BASE_URL + item.url);
})
_this.imageList = data.imageList

_this.$set(_this, 'detailsData', data)

}).then(() => {
document.title = _this.detailsData.name
_this.getfoodList()
});
},


getfoodList () {
const _this = this
const querystring = require('querystring');
const allXcEsQuery = new EsQuery()
allXcEsQuery
.addSort("sort", allXcEsQuery.desc, false)
.addPage(0, 6)
const allXcEsJsonQuery = JSON.stringify(allXcEsQuery.getArray())
_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: _this.INDEX_NAME_TYPE.produce,
esJsonQuery: allXcEsJsonQuery
})).then(function (res) {
let list = res.data.data
let flag = -1
list.forEach((item, index) => {
if (item._id === _this.detailsData.id) {
flag = index
}
})
if (flag > -1) {
list.splice(flag, 1)
}
_this.$set(_this, 'foodList', list)
})
},

getRankList (prop) { //升序
return function (obj1, obj2) {
let val1 = obj1._source[prop].slice(0, -2);
let val2 = obj2._source[prop].slice(0, -2);
if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
val1 = Number(val1);
val2 = Number(val2);
}
if (val1 < val2) {
return -1;
} else if (val1 > val2) {
return 1;
} else {
return 0;
}
}
},

windowScroll: function () {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

if (scrollTop > this.$refs.topBox.offsetHeight / 2) {
this.showBtn = true
this.once = true
} else {
this.showBtn = false
}
},















seMore () {
if (this.showNum == 3) {
this.showNum = this.diningList.length
} else {
this.showNum = 3
}
},
book () {

if (this.detailsData && this.detailsData.phone && this.detailsData.phone != "暂无") {
const param = {
phone: this.detailsData.phone
}
payPublic.callPhone(param)
} else {
alert("暂无电话")
}
},

},
destroyed () {
const _this = this
window.removeEventListener('scroll', _this.windowScroll)
}
}
